<template lang="pug">
.search-bar
    .global-bg(v-if="showBg" @click="hideItem()")
    .tit {{lang.searchFilter}}
    .body
        .item.make
            .show-item(@click="listItem('make',$event)")
                span {{lang.globalMake}}
                em(v-if="GET.make")
                    span {{GET.make}}
                        i.fa.fa-close(@click="removeSearch(['make','model'])")
                em(v-else class="more")
                    i.fa.fa-caret-right
            .item-list(:style="'display:' + (showItem == 'make' ? '' : 'none' )")
                .t
                    .i-tit {{lang.selectMake}}
                    .iclose(@click="hideItem('make')")
                        i.fa.fa-close
                .t-search
                    i.fa.fa-search
                    input(@change="searchData('makeList')" v-model="findMake")
                .item-list-cont
                    li(v-for="item in data.makeList" v-if="findMake==''")
                        a(:href="item.url")
                           span.logo(:class="'make-'+item.css")
                           div.text
                             | {{item.typename}}
                             span.total {{item.total}}
                    template(v-if="findMake!=''")
                        template(v-for="item in data.makeList" )
                            li(v-if="item.typename.toLowerCase().indexOf(findMake) > -1 ")
                                    a(:href="item.url")
                                       span.logo(:class="'make-'+item.css")
                                       div.text
                                         | {{item.typename}}
                                         span.total {{item.total}}

        .item.modelgroup(v-if="data.isModelGroup")
            .show-item(@click="listItem('modelGroup',$event)")
                span {{lang.globalModelGroup}}
                em(v-if="GET.modelGroup")
                    span {{GET.modelGroup}}
                        i.fa.fa-close(@click="removeSearch(['modelGroup'])")
                em(v-else class="more")
                    i.fa.fa-caret-right
            .item-list(:style="'display:' + (showItem == 'modelGroup' ? '' : 'none' )")
                .t
                    .i-tit {{lang.selectModelGroup}}
                    .iclose(@click="hideItem('modelGroup')")
                        i.fa.fa-close
                .item-list-cont
                    li(v-for="item in data.modelList.group")
                        a(:href="item.url")
                           span.logo(:class="'make-'+item.css")
                           div.text
                             | {{item.typename}}
                             span.total {{item.total}}
        .item.model
            .show-item(@click="listItem('model',$event)")
                span {{lang.globalModel}}
                em(v-if="GET.model")
                    span {{GET.model}}
                        i.fa.fa-close(@click="removeSearch(['model'])")
                em(v-else class="more")
                    i.fa.fa-caret-right
            .item-list(:style="'display:' + (showItem == 'model' ? '' : 'none' )")
                .t
                    .i-tit {{lang.selectModel}}
                    .iclose(@click="hideItem('model')")
                        i.fa.fa-close
                .item-list-cont
                    li(v-for="item in data.modelList.list")
                        a(:href="item.url")
                           span.logo(:class="'make-'+item.css")
                           div.text
                             | {{item.typename}}
                             span.total {{item.total}}

        .item.province(v-if="cond.location.length>0")
            .show-item(@click="listItem('province',$event)")
                span {{lang.globalRegion}}
                em(v-if="GET.province")
                    span {{GET.province}}
                        i.fa.fa-close(@click="removeSearch(['province','city'])")
                em(v-else class="more")
                    i.fa.fa-caret-right
            .item-list(:style="'display:' + (showItem == 'province' ? '' : 'none' )")
                .t
                    .i-tit {{lang.selectRegion}}
                    .iclose(@click="hideItem('region')")
                        i.fa.fa-close
                .item-list-cont
                    li(v-for="item in cond.location" @click="goSearch('province' , item.typename)")
                        a(:href="item.url")
                           span.logo(:class="'make-'+item.css")
                           div.text
                             | {{item.typename}}

        .item.city(v-if="GET.province")
            .show-item(@click="listItem('city',$event)")
                span {{lang.globalCity}}
                em(v-if="GET.city")
                    span {{GET.city}}
                        i.fa.fa-close(@click="removeSearch(['city'])")
                em(v-else class="more")
                    i.fa.fa-caret-right
            .item-list(:style="'display:' + (showItem == 'city' ? '' : 'none' )")
                .t
                    .i-tit {{lang.selectCity}}
                    .iclose(@click="hideItem('city')")
                        i.fa.fa-close
                .item-list-cont
                    li(v-for="item in cityList" @click="goSearch('city' , item.typename)")
                        a(:href="item.url")
                           span.logo(:class="'make-'+item.css")
                           div.text
                             | {{item.typename}}
        .item.price
            .show-item(@click="listItem('price',$event)")
                span {{lang.globalPrice}}
                em(v-if="GET.minprice || GET.maxprice")
                    span {{GET.minprice}} ~ {{GET.maxprice}}
                        i.fa.fa-close(@click="removeSearch(['minprice','maxprice'])")
                em(v-else class="more")
                    i.fa.fa-caret-right
            .item-list(:style="'display:' + (showItem == 'price' ? '' : 'none' )")
                .t
                    .i-tit {{lang.selectPrice}}
                    .iclose(@click="goSearch('price')") {{lang.globalApply}}


                .t-search
                    .row
                        .col-6
                            input.form-control-sm.form-control(@focus="focusInput('showLeft')" v-model="form.minprice")
                        .col-6
                            input.form-control-sm.form-control(@focus="focusInput('showRight')"  v-model="form.maxprice")
                .item-list-cont
                    .list-range
                        .range-box(:style=" showLeft ? '' : 'visibility: hidden;' ")
                            li(v-for="(val,tag) in data.priceStep" @click="pickVal(val,'minprice')") {{tag}}
                        .range-box(:style=" showRight ? '' : 'visibility: hidden;' " )
                            li(v-for="(val,tag) in data.priceStep" @click="pickVal(val,'maxprice')") {{tag}}

        .item.year
            .show-item(@click="listItem('year',$event)")
                span {{lang.globalYear}}
                em(v-if="GET.minyear || GET.maxyear || GET.year")
                    span(v-if="GET.year") {{GET.year}}
                    span(v-else) {{GET.minyear}} ~ {{GET.maxyear}}
                        i.fa.fa-close(@click="removeSearch(['minyear','maxyear'])")
                em(v-else class="more")
                    i.fa.fa-caret-right
            .item-list(:style="'display:' + (showItem == 'year' ? '' : 'none' )")
                .t
                    .i-tit {{lang.selectYear}}
                    .iclose(@click="goSearch('year')") {{lang.globalApply}}

                .t-search
                    .row
                        .col-6
                            input.form-control-sm.form-control(@focus="focusInput('showLeft')" v-model="form.minyear")
                        .col-6
                            input.form-control-sm.form-control(@focus="focusInput('showRight')"  v-model="form.maxyear")
                .item-list-cont
                    .list-range
                        .range-box(:style=" showLeft ? '' : 'visibility: hidden;' ")
                            li(v-for="val in data.yearStep" @click="pickVal(val,'minyear')") {{val}}
                        .range-box(:style=" showRight ? '' : 'visibility: hidden;' " )
                            li(v-for="val in data.yearStep" @click="pickVal(val,'maxyear')") {{val}}
</template>
<script>
    import  $ from "jquery";
    export default {
        name: 'SearchFilter',
        data() {
            return {
                data : window.searchBar,
                lang : window.LANG,

                GET : window.GET,
                cond : window.searchConst,

                showBg : false,

                showMake : "none",
                showItem : '',
                cityList : [],

                showLeft : false,
                showRight : false,
                form : {
                    getType : "",
                    minprice : "",
                    maxprice : "",
                    minyear : "",
                    maxyear : "",
                    province : "",
                    make: "",
                    model:"",
                    modelGroup : "",
                    city : "",
                    year : "",
                },
                findMake : ""
            }
        },
        beforeMount: function () {
            //
            this.data.yearStep = window.searchConst.yearStep;
            this.data.priceStep = window.searchConst.priceStep;

            if ( this.data.isModelGroup && this.GET.modelGroupDetail ){
                this.setModelList();
            }

            for(var x in this.form){
                if ( this.GET[x] && this.form[x] == ''){
                    this.form[x] = this.GET[x];
                }
            }

            this.setCityList();

        },
        methods : {
            listItem : function( type , event){
                //skip the close button
                if ( event.target.className.indexOf('fa-close') > -1){
                    return ;
                }
                this.showBg = true;
                this.showItem = type;
                console.log(event.target , event.target.className );
            },
            hideItem : function(){
                this.showBg = false;
                this.showItem = '';
            },
            remove : function(item){

            },
            removeSearch : function(items){
                for(var x in items){
                    this.form[items[x]] = '';
                }
                this.goSearch();
            },
            goSearch : function(field , value ){

                if ( field == 'year'){
                    if ( this.form.minyear == this.form.maxyear && this.form.minyear > 0){
                        this.form.year = this.form.minyear;
                        this.form.minyear = this.form.maxyear = '';
                    } else if ( this.form.minyear != this.form.maxyear && this.form.minyear > 0){
                        this.form.year = '';
                    }
                }


                if ( field != null && field !== '' && ['year','price'].indexOf(field) === -1 ){
                    this.form[field] = value;
                }
                if ( field == 'province' ){
                    this.form.city = '';
                }
                this.form.getType = this.data.getType;
                var url = this.data.urlPre;
                var params = '';
                for(var x in this.form ){
                    params += `&${x}=${this.form[x]}`
                }
                if ( url.indexOf('?') == -1 ){
                    url = url + "?" + params.substr(1);
                }

                location.href = url;
            },

            findModelListById : function( id ){
                var item = this.data.modelList.group;
                for(var x in item){
                    if ( item[x].id == id ){
                        return item[x].kids;
                    }
                }
            },

            findListByName : function( name , list ){
                for(var x in list){
                    if ( item[x].typename == name ){
                        return item[x].kids;
                    }
                }
                return [];
            },
            findKeyByName : function( name , list){
                for(var x in list){
                    if ( list[x].typename == name ){
                        return x;
                    }
                }
                return 0;
            },

            setModelList : function(){
                var modelItem = this.findModelListById( this.GET.modelGroupDetail.id );
                this.data.modelList.list =  modelItem;
            },

            focusInput : function( type ){
                this[type] = true;
                if ( type === 'showRight' ){
                    this.showLeft = false;
                } else if ( type == 'showLeft') {
                    this.showRight = false;
                }
            },

            pickVal : function( val , setToValName){
                this.form[setToValName] = val;
            },

            setCityList : function(){
                if ( typeof this.GET.province == 'undefined' ||  this.GET.province == ""){
                    return;
                }
                var key = this.findKeyByName( this.GET.province , this.cond.location );
                this.cityList = this.cond.location[key].kids;
            },
            searchData : function(key){

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/SearchFilter.vue